module.exports = __webpack_public_path__ + "img/content-01.c6a358b3.png";